<template>
  <div style="display: contents;">
    <tr :class="isUnpaid ? 'table-danger' : ''">
      <td width="1%">
        <b-icon :icon="collapsed ? 'dash-square' : 'plus-square'" @click="collapsed = !collapsed" variant="primary" class="font-weight-bold"/>
      </td>
      <td><a href="" @click.prevent="$emit('view')" class="text-info">{{ booking.id }}</a></td>
      <td>{{ toDate(booking.booking_date, 'DD-MM-YYYY') }}</td>
      <td>
        <span class="text-warning" v-if="booking.supplier_status === 'option' "><b>OPT</b></span>
        <span class="text-success" v-if="booking.supplier_status === 'confirmed'"><b>CONF</b></span>
        <span class="text-danger" v-if="booking.supplier_status === 'on_request' "><b>REQ</b></span>
      </td>
      <td>{{ booking.client_ref }}</td>
      <td>{{ round(booking.gross + booking.tax) }} {{ booking.currency }}</td>
      <td>{{ round(booking.paid_amount) }} {{ booking.currency }}</td>
      <td>{{ round(booking.gross + booking.tax - booking.commission - booking.paid_amount) }} {{ booking.currency }}</td>
      <td>{{ toDate(booking.balance_due_date, 'DD-MM-YYYY') }}</td>
      <td class="text-right"><a href="" @click.prevent="$emit('view')" class="btn btn-primary btn-sm" v-if="booking.has_invoice">Facturi</a></td>
    </tr>
    <template v-if="collapsed">
      <PackageItemResult
        v-for="(item, itemIndex) in booking.packages"
        :item="item"
        :booking="booking"
        :key="'item' + itemIndex" />
      <BookingItemResult
        v-for="(item, itemIndex) in booking.items"
        :item="item"
        :booking="booking"
        :key="'item' + itemIndex" />
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import BookingItemResult from './booking_item_result'
import PackageItemResult from './package_item_result'
import { round } from '@/shared/utils'

export default {
  name: 'BookingResult',
  props: ['booking'],
  components: { BookingItemResult, PackageItemResult },
  data () {
    return {
      collapsed: false,
      secondCollapsed: false,
      isUnpaid: (this.booking.gross + this.booking.tax - this.booking.commission) > this.booking.paid_amount,
      round
    }
  },
  methods: {
    toDate (date, format) {
      return moment.unix(date).format(format)
    }
  }
}
</script>
